import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function TestimonialSection() {
  const { ref: quoteRef, isVisible: quoteVisible } = useScrollAnimation({ threshold: 0.3 });
  const { ref: imageRef, isVisible: imageVisible } = useScrollAnimation({ threshold: 0.3 });

  return (
    <section className="py-16 sm:py-24 lg:py-36 px-4 sm:px-6 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Column - Quote */}
          <div ref={quoteRef} className="relative">
            <div
              className={`text-slate-blue/20 text-[72px] sm:text-[100px] lg:text-[120px] font-serif leading-none mb-4 sm:mb-10 transition-all duration-700 ease-out ${
                quoteVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
              }`}
            >
              &ldquo;
            </div>
            <blockquote
              className={`text-navy text-xl sm:text-2xl lg:text-[28px] font-serif leading-relaxed mb-6 sm:mb-8 transition-all duration-700 ease-out delay-200 ${
                quoteVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Mediline delivered and installed our mobile MRI unit in 72 hours during our renovation. Their logistics team handled everything — delivery, power setup, and site coordination. Our radiology team was scanning patients by day three.
            </blockquote>
            <div
              className={`flex items-center gap-3 transition-all duration-700 ease-out delay-400 ${
                quoteVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <div>
                <p className="text-navy text-base sm:text-lg font-semibold">Dr. Sarah Chen</p>
                <div className="flex items-center gap-2">
                  <p className="text-slate-blue text-sm sm:text-[15px]">
                    Director of Radiology, Mercy Hospital System
                  </p>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-verified-badge-fill text-green-600 text-base"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Image */}
          <div ref={imageRef} className="relative">
            <div
              className={`rounded-lg overflow-hidden h-[300px] sm:h-[400px] lg:h-[500px] transition-all duration-1000 ease-out ${
                imageVisible ? 'opacity-100 translate-x-0 rotate-0' : 'opacity-0 translate-x-20 rotate-3'
              }`}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/359406c1feb80b6f7281a848c6059cfe.jpg"
                alt="Dr. Sarah Chen"
                className="w-full h-full object-cover object-top grayscale transition-transform duration-700 hover:scale-105"
              />
            </div>
            {/* Decorative Element */}
            <div
              className={`absolute -bottom-4 -left-4 w-16 h-16 sm:w-24 sm:h-24 border-4 border-slate-blue/20 rounded-lg transition-all duration-700 ease-out delay-300 hidden sm:block ${
                imageVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
              }`}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}
